import React from 'react';
import { Image, Pressable, Text, useWindowDimensions } from 'react-native';

import exploreButtonBackground from '../../assets/images/buttons/exploreButtonBackground.png';
import { styles } from './styles';

const PlayButton = ({ onPress }) => {
  const { height } = useWindowDimensions();

  return (
    <Pressable
      onPress={onPress}
      style={[
        styles.container,
        {
          marginTop: 0.05 * height,
        },
      ]}>
      <Image
        source={exploreButtonBackground}
        style={{
          height: 0.07 * height,
          width: 4.7 * 0.055 * height,
          resizeMode: 'contain',
          alignSelf: 'center',
        }}
      />
      <Text
        style={[
          styles.text,
          {
            fontSize: 0.02 * height,
            transform: [{ rotate: '4.8deg' }, { translateX: 3 }],
          },
        ]}>
        Conheça o prédio
      </Text>
    </Pressable>
  );
};

export default PlayButton;
